import React from "react";

import { Button, Modal, MainView } from "lib/components";
import styles from "./NewOrderModalView.less";

export function NewOrderModalView({ children, open, onClose, loading, ...props }) {
  return (
    <Modal {...props} closeIcon closeOnDimmerClick={false} open={open} size="large" onClose={onClose}>
      <div className={styles["view"]}>
        <MainView.Dimmer loading={loading} />
        {children}
      </div>
    </Modal>
  );
}

NewOrderModalView.Container = NewOrderModalViewContainer;
export function NewOrderModalViewContainer({ children, className = "", ...props }) {
  return (
    <div {...props} className={className + " " + styles["container"]}>
      {children}
    </div>
  );
}

NewOrderModalView.Header = NewOrderModalViewHeader;
export function NewOrderModalViewHeader({ children, className = "", ...props }) {
  return (
    <div {...props} className={className + " " + styles["header"]}>
      {children}
    </div>
  );
}

NewOrderModalView.Content = NewOrderModalViewContent;
export function NewOrderModalViewContent({ children, className = "", ...props }) {
  return (
    <div {...props} className={className + " " + styles["content"]}>
      {children}
    </div>
  );
}

NewOrderModalView.Actions = NewOrderModalViewActions;
export function NewOrderModalViewActions({
  goBack,
  submit,
  goBackDisabled,
  submitDisabled,
  goBackContent = I18n.t("papp.common.go_back"),
  submitContent = I18n.t("papp.common.save"),
  className,
  ...props
}) {
  return (
    <div {...props} className={className + " " + styles["actions"]}>
      <Button.Group fluid size="huge">
        <Button as="a" basic onClick={goBack} disabled={goBackDisabled} content={goBackContent} />
        <Button as="a" primary onClick={submit} disabled={submitDisabled} content={submitContent} />
      </Button.Group>
    </div>
  );
}

NewOrderModalView.Sidebar = NewOrderModalViewSidebar;
export function NewOrderModalViewSidebar({ children, className = "", ...props }) {
  return (
    <div {...props} className={className + " " + styles["sidebar"]}>
      {children}
    </div>
  );
}

export default NewOrderModalView;



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderModalView.jsx